import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
    properties: Record<string, string | null>;
};

export function MapEditorFeatureProperties({ properties }: Props) {
    const { t } = useTranslation("mapEditor");
    const entries = Object.entries(properties);

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>{t("mapEditorFeatureDetails.labelKey")}</TableCell>
                    <TableCell>{t("mapEditorFeatureDetails.labelValue")}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {entries.length > 0 ? (
                    entries.map(([key, value]) => (
                        <TableRow key={key} sx={TABLE_ROW_STYLES}>
                            <TableCell>{key}</TableCell>
                            {typeof value === "string" && (
                                <TableCell sx={{ whiteSpace: "pre-wrap" }}>{value}</TableCell>
                            )}
                        </TableRow>
                    ))
                ) : (
                    <TableRow>
                        <TableCell>-</TableCell>
                        <TableCell>-</TableCell>
                    </TableRow>
                )}
            </TableBody>
        </Table>
    );
}

const TABLE_ROW_STYLES = {
    "&:last-child td, &:last-child th": {
        border: 0,
    },
};
